import { render, staticRenderFns } from "./lotteryDetails.vue?vue&type=template&id=35e76635&scoped=true&"
import script from "./lotteryDetails.vue?vue&type=script&lang=js&"
export * from "./lotteryDetails.vue?vue&type=script&lang=js&"
import style0 from "./lotteryDetails.vue?vue&type=style&index=0&id=35e76635&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e76635",
  null
  
)

export default component.exports